import { render, staticRenderFns } from "./Sk00701.vue?vue&type=template&id=38bc9ba1&scoped=true"
import script from "./Sk00701.vue?vue&type=script&lang=js"
export * from "./Sk00701.vue?vue&type=script&lang=js"
import style0 from "./Sk00701.vue?vue&type=style&index=0&id=38bc9ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc9ba1",
  null
  
)

export default component.exports